// extracted by mini-css-extract-plugin
export default {"cls1":"TnNWmkWqDD24jZiU9zIC","cls2":"wAzLu4aAIMpKCKiTlx3k TnNWmkWqDD24jZiU9zIC"};